<template>
    <b-card>
        <div style="width:60%; margin:auto; padding-bottom:20px;">
            <div class="d-flex justify-content-center " >
                <img
                    class="img-fluid"
                    alt="sanctions-list"
                    src="/illustrations/send-mail.png"
                />
            </div>

            <div class="text-center h2 mt-2">
                 <div variant="primary" disabled>
                    <b-spinner v-if="isMailSending" style="width: 1.6rem; height: 1.6rem;" variant="primary" type="grow"></b-spinner>
                    {{ mailStatus }}
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
import { BCard, BSpinner } from "bootstrap-vue";
import SigningList from "@/models/SigningList";
import Client from '@/models/Client';
import { errorToast } from "@/views/helpers/toast";
import { SEND_SIGNATURE_INVITATION_MAIL_ERROR, SOMETHING_WENT_WRONG } from "@/constants/errors";

export default {
    components: {
        BCard,
        BSpinner
    },

    data() {
        return {
            isMailSending: true,
            mailStatus: "Sending your emails...",
        };
    },

    async created() {
        const {query} = this.$route;
        // user cancelled the permission to send the mail
        if (query.error) {
            errorToast("We couldn't sent the emails because the access to send the mail has been denied.");
            setTimeout(() => {
                window.close();
            }, 3500);

            return;
        }
        
        const token = await SigningList.makeGmailToken(query.code);
        const comingFrom = this.$cache?.get('is_coming_form');
        
        if(comingFrom === 'signing-document-process') {
            SigningList.sendSignatureInvitationMail({
                token,
                userId: this.$store.getters['auth/user'].id, 
                companyId: this.$store.getters['company/getCurrentCompany'].id, 
                process: this.$store.getters['document/getCurrentProcess'],
                documentIds: this.$store.getters['document/getCurrentSelectedDocuments']?.toString(),
            })
                .then(() => {
                    setTimeout(() => {
                        localStorage.signatureInvitationMailSent = true;
                        window.close();
                    }, 2000);
                })
                .catch(sendSignatureInvitationMailError => {
                    errorToast(SEND_SIGNATURE_INVITATION_MAIL_ERROR);
                    console.log("Error while trying to send signature invitationMail", sendSignatureInvitationMailError);
                });
                
            setTimeout(() => {
                this.isMailSending = false;
                this.mailStatus = "Emails sent successfully!";
            }, 4000);
        }

        if(comingFrom === 'rons') {
            Client.sendRONSMail({
                token,
                clientIds: this.$store.getters['client/getCurrentSelectedClients'],
            })
                .then(() => {
                    setTimeout(() => {
                        localStorage.ronsMailSent = true;
                        window.close();
                    }, 2000);
                })
                .catch(error => {
                    errorToast(SOMETHING_WENT_WRONG);
                    console.log("Error wile trying to send mail", error);
                });
        }
    },
};
</script>